module.exports = __webpack_public_path__ + "static/media/UGV-Robotics-Plus.9b37df13.jpg";